import React from "react";
import { Row, Col } from "react-bootstrap";

const PersonalInformation = ({
  history,
  ClientInfo,
  Group_info,
  ClientInfo2,
  traductions,
}) => {
  //  (ClientInfo.type_requested == 'business')

  const renderPersonalInformation = () => {
    return (
      <>
        <p>{traductions.settings.personal.titleBasic} :</p>
        <Row>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_FistName} :</p>
            <p>{ClientInfo.first_name}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_fatherLastName} :</p>
            <p>{ClientInfo.last_name_p}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_motherLastName} :</p>
            <p>{ClientInfo.last_name_m}</p>
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_DateBirth}:</p>
            <p>{ClientInfo.birthdate}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_Country}:</p>
            <p>{ClientInfo.country}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_Curp}:</p>
            <p>{ClientInfo.curp}</p>
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_rfc}:</p>
            <p>{ClientInfo.rfc}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_Profession}:</p>
            <p>{ClientInfo.economic_activity}</p>
          </Col>
          <Col lg={4} md={6} sm={12}></Col>
        </Row>

        <hr />
        {renderAddressInformation()}
      </>
    );
  };

  const renderBusinessInformation = () => {
    return (
      <>
        <p>{traductions.settings.personal.titleCompany} :</p>
        <Row>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.bussines_name} :</p>
            <p>{ClientInfo.company_name}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.bussines_country} :</p>
            <p>{ClientInfo.country}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.bussines_date} :</p>
            <p>{ClientInfo.birthdate}</p>
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.bussines_rfc} :</p>
            <p>{ClientInfo.rfc}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.bussines_line} :</p>
            <p>{ClientInfo.business_line}</p>
          </Col>
          <Col lg={4} md={6} sm={12}></Col>
        </Row>
        <p>{traductions.settings.personal.titleRepresentative} :</p>
        <Row>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_name} :</p>
            <p>{ClientInfo.first_name}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_fatherLastName} :</p>
            <p>{ClientInfo.last_name_p}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_motherLastName} :</p>
            <p>{ClientInfo.last_name_m}</p>
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_DateBirth} :</p>
            <p>{ClientInfo.birthdate_rep}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_CountryBirth} :</p>
            <p>{ClientInfo.country_rep}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.L_Curp} :</p>
            <p>{ClientInfo.curp}</p>
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.bussines_rfc} :</p>
            <p>{ClientInfo.rfc_rep}</p>
          </Col>
          <Col lg={4} md={6} sm={12}></Col>
          <Col lg={4} md={6} sm={12}></Col>
        </Row>

        <hr />
        {renderAddressInformation()}
      </>
    );
  };

  const renderAddressInformation = () => {
    return (
      <>
        <p>{traductions.settings.personal.titleAddress} :</p>
        <Row>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.Addss_Country} :</p>
            <p>{ClientInfo.address_country}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.Addss_State} :</p>
            <p>{ClientInfo.address_state}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.Addss_Municipio} :</p>
            <p>{ClientInfo.address_municipality}</p>
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.Addss_City} :</p>
            <p>{ClientInfo.address_city}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.Addss_Colony} :</p>
            <p>{ClientInfo.address_distric}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.Addss_Street} :</p>
            <p>{ClientInfo.address_street}</p>
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.Addss_id} :</p>
            <p>{ClientInfo.address_number_ext}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.Addss_Int} :</p>
            <p>{ClientInfo.address_number_int}</p>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <p>{traductions.settings.personal.Addss_Zip} :</p>
            <p>{ClientInfo.address_zipcode}</p>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      <div>
        <p className="title-container-shadow" style={{ marginBottom: 16 }}>
          {traductions.settings.personal.title}
        </p>
        <div className="Data">
          <p>{traductions.settings.personal.titleAccount}:</p>
          <Row>
            <Col lg={4} md={6} sm={12}>
              <p>{traductions.settings.personal.L_email}:</p>
              <p>{localStorage.getItem("email")}</p>
            </Col>
            <Col lg={4} md={6} sm={12}>
              <p>{traductions.settings.personal.L_name}:</p>
              <p>{ClientInfo2.first_name + " " + ClientInfo2.last_name}</p>
            </Col>
            <Col lg={4} md={6} sm={12}>
              <p>{traductions.settings.personal.L_Country}:</p>
              <p>{ClientInfo2.country}</p>
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={6} sm={12}>
              <p>{traductions.settings.personal.L_Status}:</p>
              <p>{ClientInfo2.status}</p>
            </Col>
            <Col lg={4} md={6} sm={12}>
              <p>{traductions.settings.personal.L_Last_Login}:</p>
              <p>{ClientInfo2.last_login_date}</p>
            </Col>
            <Col lg={4} md={6} sm={12}>
              <p>{traductions.settings.personal.L_Registration_Date}:</p>
              <p>{ClientInfo2.registration_date}</p>
            </Col>
          </Row>
          <hr />
          {ClientInfo.type != "free" ? (
            ClientInfo.type_requested == "business" ? (
              renderBusinessInformation()
            ) : (
              ClientInfo.type_requested == "personal" &&
              renderPersonalInformation()
            )
          ) : ClientInfo.pending_upgrade == "rejected" ? (
            <div className="incompleteRecord">
              <p style={{ margin: 0 }}>
                {traductions.General.registerResponse.rejected1}.
              </p>
              <p>
                {traductions.General.registerResponse.rejected2}{" "}
                <span className="link" onClick={() => history.push("/kyc")}>
                  {traductions.General.registerResponse.click}
                </span>
              </p>
            </div>
          ) : ClientInfo.pending_upgrade != "False" ? (
            <div className="incompleteRecord">
              <p style={{ margin: 0 }}>
                {traductions.General.registerResponse.revision}
              </p>
            </div>
          ) : (
            <div className="incompleteRecord">
              <p>{traductions.General.registerResponse.unregistered1}</p>
              <p>
                {traductions.General.registerResponse.unregistered2}{" "}
                <span className="link" onClick={() => history.push("/kyc")}>
                  {traductions.General.registerResponse.click}
                </span>
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PersonalInformation;
